"use strict";

// This script is needed combined with ".useable.css" for angular-css to behave like before the introduction of webpack.
// See: http://stackoverflow.com/questions/40230069/how-to-unload-css-when-changing-route-using-webpack/40230096#40230096
angular.module("core").factory("CssUseableActivator", function($rootScope) {
    return {
        init: function() {
            $rootScope.$on("$cssAdd", function(event, stylesheets) {
                angular.forEach(stylesheets, function(stylesheet) {
                    if (stylesheet.use) {
                        stylesheet.use();
                    }
                });
            });
            $rootScope.$on("$cssRemove", function(event, stylesheets) {
                angular.forEach(stylesheets, function(stylesheet) {
                    if (stylesheet.unuse) {
                        stylesheet.unuse();
                    }
                });
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/css-useable-activator/css-useable-activator.factory.js
// module id = 454
// module chunks = 0